

<div class="full-width">
  <highcharts-chart 
    *ngIf="isHighcharts"
    [style.visibility]="hasData===false? 'hidden': 'visible'"
    [Highcharts]="Highcharts"
    [constructorType]="chartConstructor"
    [options]="chartOptions"
    [callbackFunction]="chartCallback"
    [(update)]="updateFlag"
    [oneToOne]="true"
    style="width: 100%; height: 315px; display: block; width:auto"
    class="align-center"
    >
  </highcharts-chart>
</div>
